import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import { ThemeProvider } from "./ThemeContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Loans from "./pages/Loans";
import Commissions from "./pages/Commissions";
import Exceptions from "./pages/Exceptions";
import Tiers from "./pages/Tiers";
import Upload from "./pages/Upload";
import Users from "./pages/Users";
import InviteUsers from "./pages/InviteUsers";
import AcceptInvite from "./pages/AcceptInvite";
import PayrollPeriodDetail from "./pages/PayrollPeriodDetail";
import PayrollSettings from "./pages/PayrollSettings";
import LoanOfficers from "./pages/LoanOfficers";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",color:"var(--text-muted)"}}>
      Loading...
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login"                element={<Login />} />
            <Route path="/forgot-password"      element={<ForgotPassword />} />
            <Route path="/reset-password"       element={<ResetPassword />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/dashboard"    element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/loans"        element={<ProtectedRoute><Loans /></ProtectedRoute>} />
            <Route path="/commissions"  element={<ProtectedRoute><Commissions /></ProtectedRoute>} />
            <Route path="/exceptions"   element={<ProtectedRoute><Exceptions /></ProtectedRoute>} />
            <Route path="/tiers"        element={<ProtectedRoute><Tiers /></ProtectedRoute>} />
            <Route path="/upload"       element={<ProtectedRoute roles={["admin"]}><Upload /></ProtectedRoute>} />
            <Route path="/users"        element={<ProtectedRoute roles={["admin","manager"]}><Users /></ProtectedRoute>} />
            <Route path="/invite"              element={<ProtectedRoute roles={["admin","manager"]}><InviteUsers /></ProtectedRoute>} />
            <Route path="/commissions/period/:periodId" element={<ProtectedRoute><PayrollPeriodDetail /></ProtectedRoute>} />
            <Route path="/settings/payroll"    element={<ProtectedRoute roles={["admin"]}><PayrollSettings /></ProtectedRoute>} />
            <Route path="/loan-officers"       element={<ProtectedRoute roles={["admin"]}><LoanOfficers /></ProtectedRoute>} />
            <Route path="*"                    element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
